export const columns = [
  {
    title: "文件名称",
    key: "name",
    dataIndex: "name",
  },
  {
    title: "文件类型",
    width: 150,
    key: "suffix",
    dataIndex: "suffix",
  },
  {
    title: "文件大小",
    width: 150,
    slots: { customRender: "size" },
  },
  {
    title: "状态",
    width: 150,
    slots: { customRender: "status" },
  },
  {
    title: "操作",
    width: 100,
    slots: { customRender: "action" },
  },
];
